function normalizedSigmoid(z) {
    return sigmoid((z * 10) - 5);
}
function sigmoid(z) {
    return 1 / (1 + Math.exp(-z));
}
function normalizedTanh(x) {
    var clampedValue = Math.min(tanh(x), 0.75);
    var normalizedValue = clampedValue * 1.3333;
    return normalizedValue;
}
function tanh(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
}
var InterpolationCache = /** @class */ (function () {
    function InterpolationCache(samples, interpolation, start, end) {
        if (samples === void 0) { samples = 10; }
        if (interpolation === void 0) { interpolation = 'sigmoid'; }
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 1; }
        this._start = 0;
        this._end = 1;
        this._sampleCount = samples;
        this._interpolation = interpolation;
        this._cache = new Float32Array(this.sampleCount);
        this._start = start;
        this._end = end;
        this._generateCache();
    }
    Object.defineProperty(InterpolationCache.prototype, "start", {
        get: function () {
            return this._start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterpolationCache.prototype, "end", {
        get: function () {
            return this._end;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterpolationCache.prototype, "sampleCount", {
        get: function () {
            return this._sampleCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterpolationCache.prototype, "cache", {
        get: function () {
            return this._cache;
        },
        enumerable: false,
        configurable: true
    });
    InterpolationCache.prototype.getCachedValue = function (progress) {
        var sampleIndex = Math.floor(progress * (this.sampleCount - 1));
        if (sampleIndex < 0) {
            return this._cache[0];
        }
        if (sampleIndex >= this.sampleCount) {
            return this._cache[this.sampleCount - 1];
        }
        return this._cache[sampleIndex];
    };
    InterpolationCache.prototype._generateCache = function () {
        switch (this._interpolation) {
            case 'stepped':
                return this._generateStepCache();
            case 'tan':
                return this._generateTanCache();
            case 'sigmoid':
                return this._generateSigmoidCache();
            default:
                throw new Error("Unknown interpolation type: ".concat(this._interpolation));
        }
    };
    InterpolationCache.prototype.remapValue = function (value) {
        return this.start + ((this.end - this.start) * value);
    };
    InterpolationCache.prototype._generateStepCache = function () {
        for (var i = 0; i < this.sampleCount; i++) {
            var x = i / (this.sampleCount - 1);
            if (x <= 0.5) {
                this._cache[i] = this.remapValue(0);
            }
            else {
                this._cache[i] = this.remapValue(1);
            }
        }
    };
    InterpolationCache.prototype._generateTanCache = function () {
        for (var i = 0; i < this.sampleCount; i++) {
            var x = i / (this.sampleCount - 1);
            this._cache[i] = this.remapValue(normalizedTanh(x));
        }
    };
    InterpolationCache.prototype._generateSigmoidCache = function () {
        for (var i = 0; i < this.sampleCount; i++) {
            var x = i / (this.sampleCount - 1);
            this._cache[i] = this.remapValue(normalizedSigmoid(x));
        }
    };
    return InterpolationCache;
}());
export { InterpolationCache };
